export default __webpack_public_path__ + "static/media/msg.bb787f3a.svg";